import * as React from "react";

import { style, Icon } from "./Symbolicons";

export const Edit = (props: Icon): React.ReactElement => {
  if (props.variant === "line") {
    return (
      <svg
        viewBox="0 0 24 24"
        style={{ ...style(props.size, props.height), ...props.style }}
        className={props.className}
      >
        <g
          stroke={props.color || "currentColor"}
          strokeWidth={2}
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            d="M16.302 3.977l3.721
            3.72M18.51 1.772L8.463 11.818 7
            17l5.182-1.461L22.23 5.492a2.63 2.63 0 1 0-3.721-3.721z"
          />
          <path d="M8 6H5a4 4 0 0 0-4 4v9a4 4 0 0 0 4 4h9a4 4 0 0 0 4-4v-3" />
        </g>
      </svg>
    );
  }
  return (
    <svg
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path
        d="M7.668 12.091l-1.667 5.91 5.91-1.667
        8.333-8.333-4.243-4.243-8.333
        8.333zM23.122.88a2.978 2.978 0 0 0-2.121-.879c-.801
        0-1.555.312-2.121.879l-1.464 1.464 4.243 4.243
        1.464-1.464a2.98 2.98 0 0 0 .879-2.121 2.982 2.982 0 0
        0-.88-2.122zm-5.121 14.121a1 1 0 0 0-1 1v5c0 .551-.448
        1-1 1h-13c-.552 0-1-.449-1-1v-13c0-.551.448-1 1-1h5a1 1 0 1 0
        0-2h-5c-1.654 0-3 1.346-3 3v13c0 1.654 1.346 3 3 3h13c1.654
        0 3-1.346 3-3v-5a1 1 0 0 0-1-1z"
        fill={props.color || "currentColor"}
        fillRule="nonzero"
      />
    </svg>
  );
};
